import { Component, Inject, ViewChild } from '@angular/core';
import { PlatformLicensePricingFormComponent } from '../../components/platform-license-pricing-form/platform-license-pricing-form.component';
import { platformLicenseActionLoading } from 'src/app/store/reducer/platform-license.reducer';
import { IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { UpsertPlatformLicensePricing } from 'src/app/store/actions/platform-license.actions';
import { waitForBooleanValue } from '../../utils';
import { PlatformLicenseEntity } from 'src/app/store/entity-models';

export interface CreatePlatformLicensePricingDialogData {
    platformLicense: PlatformLicenseEntity;
}

@Component({
    standalone: false,
    selector: 'app-create-platform-license-pricing-dialog',
    templateUrl: './create-platform-license-pricing-dialog.component.html',
    styleUrls: ['./create-platform-license-pricing-dialog.component.scss']
})
export class CreatePlatformLicensePricingDialogComponent {
    @ViewChild('platformLicensePricingForm') platformLicensePricingForm: PlatformLicensePricingFormComponent;

    loading$ = this.store.select(platformLicenseActionLoading);

    public modalOptions = {
        size: IotaModalSize.SIZE_7XL
    };
    formValid = false;

    constructor(
        private dialogRef: MatDialogRef<CreatePlatformLicensePricingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CreatePlatformLicensePricingDialogData,
        private store: Store
    ) {}

    updateFormValidity(formValid: boolean) {
        this.formValid = formValid;
    }

    async save() {
        const platformLicensePricing = this.platformLicensePricingForm?.getUpsertedPlatformLicensePricing();
        if (!!platformLicensePricing) {
            this.store.dispatch(
                UpsertPlatformLicensePricing({ platformLicenseId: this.data?.platformLicense?.platformLicenseId, platformLicensePricing })
            );
        }

        await waitForBooleanValue(this.store, platformLicenseActionLoading, false);
        this.closeDialog();
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
